import {Injectable} from '@angular/core';
import {SchedulerServiceBase} from './scheduler.service.base';

export {ContentType, Playlist, PlaylistEntry} from './scheduler.service.base';

@Injectable()
export class SchedulerService extends SchedulerServiceBase {
}
